<template>
  <li
    class="member-indoor-item-place-node"
    v-bind:class="{ selected: isSelected }"
    v-bind:style="{ '--padding-left-add': `${(indent - 1) * 48 + 36}px` }"
    v-on:click="$_onItemClick"
  >
    <!-- ラベル -->
    <div class="item-label">
      <div class="icon-wrapper">
        <point-icon v-if="geometryType === 'Point'" class="point-icon" />
        <linestring-icon
          v-else-if="geometryType === 'LineString'"
          class="linestring-icon"
        />
        <polygon-icon
          v-else-if="geometryType === 'Polygon'"
          class="polygon-icon"
        />
        <div v-else class="null-icon" />
      </div>
      <div class="item-name">
        {{ name }}
      </div>
    </div>
    <!-- ユーザー数 -->
    <div class="counts">
      <template v-if="showUsersCount">
        <b-row no-gutters class="users-count">
          <user-icon class="user-icon" />
          <span>
            {{ usersCount }}
            {{ $t('appMemberIndoorItemPlaceNode.case') }}
          </span>
        </b-row>
        <!-- タグユーザー -->
        <b-row
          v-if="$store.getters['user/hasTagUser']"
          no-gutters
          class="users-count"
        >
          <tag-user-icon class="user-icon" />
          <span>
            {{ tagUsersCount }}
            {{ $t('appMemberIndoorItemSiteNode.case') }}
          </span>
        </b-row>
      </template>
    </div>
  </li>
</template>

<script>
import PointIcon from '@/assets/ifield/ic_place_point.svg?component'
import LinestringIcon from '@/assets/ifield/ic_place_line.svg?component'
import PolygonIcon from '@/assets/ifield/ic_place_polygon.svg?component'
import UserIcon from '@/assets/ifield/ic_user.svg?component'
import TagUserIcon from '@/assets/ifield/ic_tag_user.svg?component'
import { TAG_USER_ROLE_ID } from 'ifield-core-components'

export default {
  name: 'AppMemberIndoorItemPlaceNode',
  components: {
    'point-icon': PointIcon,
    'linestring-icon': LinestringIcon,
    'polygon-icon': PolygonIcon,
    'user-icon': UserIcon,
    TagUserIcon,
  },
  inheritAttrs: false,
  props: {
    /**
     * ID
     */
    id: {
      type: Number,
      default: null,
    },
    /**
     * 名称
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * ジオメトリ種類
     */
    geometryType: {
      type: String,
      default: null,
    },
    /**
     * ユーザー情報
     */
    users: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択されているID
     */
    selectedId: {
      type: Object,
      default: () => {},
    },
    /**
     * インデント
     */
    indent: {
      type: Number,
      default: 0,
    },
    /**
     * ユーザー数表示フラグ
     */
    showUsersCount: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    /**
     * アイテム選択イベント
     * @param {Object} data 選択情報({ key: id })
     */
    'indoor-item-selected',
  ],
  computed: {
    /**
     * ユーザー数
     * @type {Number}
     */
    usersCount: function () {
      return this.users.filter(
        (user) => user.place_id === this.id && user.role_id !== TAG_USER_ROLE_ID
      ).length
    },
    /**
     * タグユーザー数
     * @type {Number}
     */
    tagUsersCount: function () {
      return this.users.filter(
        (user) => user.place_id === this.id && user.role_id === TAG_USER_ROLE_ID
      ).length
    },
    /**
     * 選択されている場合はtrue
     * @type {Boolean}
     */
    isSelected: function () {
      return this.selectedId.indoorPlace === this.id
    },
  },
  methods: {
    /**
     * アイテムクリック時処理
     */
    $_onItemClick: function () {
      const value = this.isSelected ? null : this.id
      this.$emit('indoor-item-selected', { indoorPlace: value })
    },
  },
}
</script>

<style lang="scss" scoped>
$-row-height: 32px;

.member-indoor-item-place-node {
  --padding-left-add: 0;
  width: 100%;
  min-height: $-row-height;
  padding: 0 8px 0 calc(8px + var(--padding-left-add));
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaecef;
  user-select: none;
  cursor: pointer;

  &.selected {
    background-color: #f7f7f7;
  }

  &.hidden {
    display: none;
  }
}

.item-label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 4px;
}

.icon-wrapper {
  width: $-row-height;
  height: $-row-height;
  display: flex;
  justify-content: center;
  align-items: center;

  .point-icon {
    fill: $text-color;
  }

  .linestring-icon,
  .polygon-icon {
    fill: none;
    stroke: $text-color;
    stroke-width: 2;
  }
}

.item-name {
  color: $text-color;
  font-size: $font-size-middle;
  font-weight: $font-weight-bold;
  text-align: left;
  margin: 4px 0;
}

.counts {
  color: $text-color-weak;
  height: 100%;
  font-size: $font-size-small;
  text-align: right;
  margin: 4px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  row-gap: 4px;

  .row {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .user-icon {
    width: 12px;
    height: 12px;
    fill: #555555;
  }
}
</style>
